import { api } from "./api";
import type { CreateUserInput, UpdateUserInput, User, UserRole } from "@/types/user";
import type { Organisation } from "@/types/organisation";

export const userService = {
  getMe: (): Promise<User> => api.get<User>("/user/me").then((res) => res.data),

  getUsers: (): Promise<User[]> => api.get<User[]>("/user").then((res) => res.data),

  getUser: (id: number | string): Promise<User> =>
    api.get<User>(`/user/${id}`).then((res) => res.data),

  // Organisations this user is a MEMBER of (reverse of
  // organisationService.getOrganisationMembers). Requires backend support for
  // GET /user/:id/organisations returning Organisation[] - not yet implemented
  // server-side as of 2026-07-22.
  getUserOrganisations: (id: number | string): Promise<Organisation[]> =>
    api.get<Organisation[]>(`/user/${id}/organisations`).then((res) => res.data),

  createUser: (userData: CreateUserInput) => api.post("/user", userData),

  updateUser: (id: number | string, userData: UpdateUserInput) =>
    api.put(`/user/${id}`, userData),

  deleteUser: (id: number | string) => api.delete(`/user/${id}`),

  updateUserRole: (id: number | string, role: UserRole) =>
    api.put(`/user/${id}/role`, { role }),
};
